import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Partner } from 'src/app/shared/models/partner';
import { PartnerGroup } from 'src/app/shared/models/partner-group';
import { PartnerGroupMember } from 'src/app/shared/models/partner-group-member';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
  selector: 'app-add-partner-to-group-modal',
  templateUrl: './add-partner-to-group-modal.component.html',
  styleUrls: ['./add-partner-to-group-modal.component.scss']
})
export class AddPartnerToGroupModalComponent implements OnInit {

  partners: Partner[] = [];

  availablePartners: { selected: boolean, partner: Partner }[];

  partnerGroup: PartnerGroup;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private userService: UserService, private partnerService: PartnerService, private snackbarService: SnackBarService, public dialogRef: MatDialogRef<AddPartnerToGroupModalComponent>) { }

  ngOnInit(): void {

    this.partnerGroup = this.data.partnerGroup;

    this.partnerService.getPartners().subscribe(x => {
      this.partnerService.setPartners(x);

      //get list of partners
      this.partnerService.partners$.subscribe((allPartners) => {
        // Exclude partners that are already members of the partnerGroup
        const memberIds = this.partnerGroup.members.map(member => member.partner.id);

        this.availablePartners = allPartners
          .filter(partner => !memberIds.includes(partner.id) && partner.name.toLowerCase() !== 'mibe music')
          .map(partner => ({
            selected: false,
            partner: partner
          }));
      });

    });


  }

  onClose(): void {
    this.dialogRef.close();
  }

  /**
   * Adds each selected partner to the group
   */

  addPartnersToGroup(){
     //create group member for each partner in group
     let addedCount = 0;

     let selectedPartners = this.availablePartners.filter(partner => partner.selected === true);


     selectedPartners.forEach(partner => {
       let member: PartnerGroupMember = {
         id: 0,
         allocationPercentage: 0,
         partnerId: partner.partner.id,
         partnerGroupId: this.partnerGroup.id,
         partner: partner.partner,
         postDilution: null, //default value
         postDilutionParentId: null,
         postDilutionChildren: null,
         expandDetails: null,
        //  postDilutionParent: null,
        //  episodes: [],
        //  selectedEpisodesCount: 0
       };

       this.partnerService.addNewPartnerGroupMember(member, this.userService.currentUser.id).subscribe(
         (resMember) => {

           //track count - once complete, show success message
           addedCount++;

           if (addedCount == selectedPartners.length) {
             //call snackbar for success message
             this.snackbarService.showSnackBarMessage("Partner(s) successfully added to Group!", 'Close')

             this.onClose();
           }
         },
         (error) => {
           //an error occurred added a partner to the group

           //call snackbar for error message
           this.snackbarService.showSnackBarMessage("An error occurred while attempting to add the partner(s) to the group.", 'Close', undefined, true);
         })
     })
  }

}
